import ApiCore from './utilities/core'
import apiProvider from './utilities/provider'

const url = 'reference-requests'

const apiReferenceRequests = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: false,
  url,
})

apiReferenceRequests.getApplicationReferences = (id) =>
  apiProvider.getAll(`${url}/application/${id}`)

export default apiReferenceRequests
